import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import InviteYourFriend from './component/InviteYourFriend';

import reducer, { initialState, init } from './store/reducer';
import {
  updateInviteEmail,
  inviteYourFriend,
  toogleIsExapnded,
} from './store/actions';

function InviteYourFriendContainer({ description }) {
  const [state, dispatch] = useReducer(reducer, initialState, init);
  const { botId } = useParams();

  const { isExpanded, email, disabled, messageType, message } = state;

  const sendInvite = () => {
    inviteYourFriend(botId)(dispatch, state);
  };

  const updateEmail = (value) => {
    updateInviteEmail(value)(dispatch);
  };

  const setIsExpanded = () => {
    toogleIsExapnded()(dispatch);
  };

  return (
    <InviteYourFriend
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      value={email}
      onChange={updateEmail}
      description={description}
      disabled={disabled}
      sendInvite={sendInvite}
      messageType={messageType}
      message={message}
    />
  );
}

InviteYourFriendContainer.propTypes = {
  description: PropTypes.string,
};

InviteYourFriendContainer.defaultProps = {
  description: '',
};

export default InviteYourFriendContainer;
